import React, { Component } from "react";
import EntryForm3 from "../../components/EntryForms/EntryForm3/EntryForm3";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import { validateRequiredFields } from "../../helperFunctions/validationHelpers/validateRequiredFields";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import Spinner from "../../components/UI/Spinner/Spinner";
import { PURGE_UPDATE } from "../../constants/constants";
import { toast } from "react-toastify";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";

class RegistarOvlastenihRevizora extends Component {
  state = {
    error: false,
    update: false,
    loader: false,
    requestsLoaded: false,
    countryList: [],
    countyList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    newFormData: {
      userData: {
        vrOsobe: "1",
        oib: "",
        oznAkt: "",
        ime: "",
        prezime: "",
        regBroj: "",
        oibValidated: false,
        requiredFieldsUserData: ["oib", "ime", "prezime"],
        tstampUnosa: null,
        telefon: "",
        email: "",
        emailValidated:false,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitDate: "",
        permitNumber: "",
        requiredFieldsAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
          "permitDate",
          "permitNumber",
        ],
      },
      reviserData: [
        {
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: 1,
          type: "",
        },
      ],
      reviserRegistration: [
        {
          funkcija:"",
          vrVeze: "",
          idDrustva: "",
          oibIdBrojDrustva: "",
          id: 1,
          ime: "",
          prezime: "",
          nazDrustva: "",
          dataFetched: false,
          sifDrzave: "",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
        },
      ],
      reviserSustainabilityApproval: {
        brojOdrzivosti: "",
        datumOdrzivosti: "",
      },
      competentBodyData: [
        {
          id: 1,
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
        },
      ],

      oznDokumenta: {
        oznDokumenta: "",
      },
      dropDownData: [
        {
          id: 1,
          value: "Ovlašteni revizor",
        },
        { id: 2, value: "Dioničar/član društva" },
        { id: 3, value: "Direktor" },
        { id: 4, value: "Predsjednik uprave" },
        { id: 5, value: "Član uprave" },
        { id: 6, value: "Prokurist" },
        { id: 7, value: "Član upravnog odbora" },
      ],
      selectedDropdownValue: "",
      strucnoUsavrsavanje: [],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getOsobaEdit = async (oznaka) => {
    const { idOsobe, vrOsobe } = this.props;

    const { data } = await axiosInstance.get(
      `/findOsoba?idOsobe=${idOsobe}&vrOsobe=${vrOsobe}&showHistory=false`
    );

    const findReviserData = data[3].filter(
      (element) => element.vrRegistracije == 2
    );

    let getReviserData;
    if (findReviserData.length > 0) {
      getReviserData = findReviserData.map((element, index) => {
        return {
          vrRegistracije: String(element.vrRegistracije),
          nazTijela: element.nazTijela || "",
          sifDrzave: element.sifDrzave || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
          type: "",
          id: index + 1,
        };
      });
    } else {
      getReviserData = this.state.newFormData.reviserData;
    }

    let getCompetentBodyData = data[3].filter(
      (element) => element.vrRegistracije == 3
    );

    let competentBodyData;
    if (getCompetentBodyData) {
      competentBodyData = getCompetentBodyData.map((element, index) => {
        return {
          vrRegistracije: "3",
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          id: index + 1,
        };
      });
    } else {
      competentBodyData = this.state.newFormData.competentBodyData;
    }

    let reviserRegistration;
    let clanstvaIRevizorstva = [];

    if(data[4].length >0){
      data[4].forEach((element) => {
        clanstvaIRevizorstva.push(element);
      });
    }
    if(data[8].length > 0){
      data[8].forEach((element)=>{
        let temp = {
          ...element,
          oibIdBrojDrustva: element.idBroj ? element.idBroj : element.oib,
        }
        switch (element.funkcija) {
          case "Dioničar/član društva":
            temp = {
              ...temp,
              vrVeze: 2,
            }
            break;
          case "Direktor":
            temp = {
              ...temp,
              vrVeze:3,
            }
            break;
          case "Predsjednik uprave":
            temp = {
              ...temp,
              vrVeze: 4,
            }
            break;
          case "Član uprave":
            temp = {
              ...temp,
              vrVeze: 5,
            }
            break;
          case "Prokurist":
            temp = {
              ...temp,
              vrVeze: 6,
            }
            break;
          case "Član upravnog odbora":
            temp = {
              ...temp,
              vrVeze: 7,
            }
            break;
          default:
            break;
        }
        clanstvaIRevizorstva.push(temp);
      })
    }
    if (clanstvaIRevizorstva.length > 0) {
      reviserRegistration = clanstvaIRevizorstva.map((element, index) => {
        return {
          vrVeze: element.vrDrustva,
          //Smislit sta ce se citat sa backenda za funkciju
          funkcija: element.vrVeze,
          idDrustva: element.idDrustva,
          oibIdBrojDrustva: element.oibIdBrojDrustva || "",
          id: index + 1,
          ime: element.imeDrustva || "",
          prezime: element.prezimeDrustva || "",
          nazDrustva: element.nazivDrustva || "",
          dataFetched: true,
          sifDrzave: element.idDrzaveDrustva,
          brPoste: element.postanskiBrojDrustva || "",
          nazNaselja: element.nazivNaseljaDrustva || "",
          ulicaKbr: element.ulicaKbrDrustva || "",
          web: element.web || "",
        };
      });
    } else {
      reviserRegistration = this.state.newFormData.reviserRegistration;
    }
    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[5].oznDokumenta;
    }

    if (data[2].sifZupanije) {
      this.getCityAndMuncipalityList(data[2].sifZupanije);
    }
    if (data[2].sifGradOpcina) {
      this.getDistrictList(data[2].sifGrdOpc);
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1]?.oznAkt || "",
          idOsobe: data[1]?.idOsobe || "",
          oib: data[1]?.oib || "",
          ime: data[1]?.ime || "",
          prezime: data[1]?.prezime || "",
          regBroj: data[1]?.regBroj || "",
          oibValidated: true,
          tstampUnosa: data[1].tstampUnosa,
          telefon: data[1]?.telefon || "",
          email: data[1]?.email || "",
          emailValidated: true,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: String(data[2].sifDrzave),
          sifZupanije: String(data[2].sifZupanije),
          nazZupanije: data[2]?.nazZupanije || "",
          sifGrdOpc: String(data[2].sifGrdOpc),
          nazGrdOpc: data[2].nazGrdOpc || "",
          sifNaselja: String(data[2].sifNaselja),
          nazNaselja: data[2]?.nazNaselja || "",
          brPoste: data[2]?.brPoste || "",
          ulicaKbr: data[2]?.ulicaKbr || "",
          permitDate: data[3][0]?.datReg || "29.11.2018",
          permitNumber: data[3][0]?.brReg || "Hrvatska revizorska komora",
        },
        reviserRegistration,
        reviserData: getReviserData,
        reviserSustainabilityApproval: {
          ...prevState.newFormData.reviserSustainabilityApproval,
          brojOdrzivosti: data[9]?.brojOdrzivosti || "",
          datumOdrzivosti: data[9]?.datumOdrzivosti || "",
        },
        competentBodyData,
        oznDokumenta,
        strucnoUsavrsavanje: data[6],
        mjere: data[7],
      },
    }));
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");

    this.setState(
      {
        countyList: data,
      },
      () => {
        if (this.checkIfUpdate("/azuriraj/registar-ovlastenih-revizora")) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          this.getOsobaEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-ovlastenih-revizora"
          )
        ) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }

          const oznDokumenta = this.props.oznDokumenta;
          this.getOsobaEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
        // !updatePage && this.disableLoader();
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => {
          if (label === "Telefon") {
            return element.controlLabel.includes(label);
          }
          return element.controlLabel == label;
        })
      );
      return findLabel;
    };

    const findCountry = findObjectByLabel("Naziv države");

    const findCity = findObjectByLabel("Naziv grada");

    const findDistrict = findObjectByLabel("Naziv mjesta");

    const findbrPoste = findObjectByLabel("Poštanski broj");

    const findUlica = findObjectByLabel("Ulica");

    const findKucniBr = findObjectByLabel("Kućni broj");

    const findTel = findObjectByLabel("Telefon");
    const findEmail = findObjectByLabel("E-mail");

    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailValidated;

    if (findEmail[0].value.length > 0) {
      emailValidated = regexp.test(findEmail[0].value);
    } else {
      emailValidated = true;
    }

    let ulicaKbr;

    if (findUlica[0].value || findKucniBr[0].value) {
      ulicaKbr = `${findUlica[0].value} ${findKucniBr[0].value}`;
    } else {
      ulicaKbr = "";
    }

    const brPoste = findbrPoste[0].value;

    const findBrRegDrugeDrzave = findObjectByLabel(
      "Broj registracije kod nadležnog tijela druge države članice"
    );

    const findNazivTijelaDrugeDrzave = findObjectByLabel(
      "Naziv nadležnog tijela iz druge države članice"
    );

    const findBrRegTreceZemlje = findObjectByLabel(
      "Broj registracije kod nadležnog tijela u trećoj zemlji"
    );

    const findNazivTijelaTreceZemlje = findObjectByLabel(
      "Naziv nadležnog tijela u trećoj zemlji"
    );

    const brRegDrDrzave = findBrRegDrugeDrzave[0]
      ? findBrRegDrugeDrzave[0].value
      : "";

    const nazTijelaDrDrzave = findNazivTijelaDrugeDrzave[0]
      ? findNazivTijelaDrugeDrzave[0].value
      : "";

    const brRegTreceZemlje = findBrRegTreceZemlje[0]
      ? findBrRegTreceZemlje[0].value
      : "";

    const nazTijelaTreceZemlje = findNazivTijelaTreceZemlje[0]
      ? findNazivTijelaTreceZemlje[0].value
      : "";

    const regDrugeDrzaveExists =
      brRegDrDrzave.length > 0 || nazTijelaDrDrzave.length > 0;

    const regTreceZemljeExists =
      brRegTreceZemlje.length > 0 || nazTijelaTreceZemlje.length > 0;

    const reviserData = [];

    if (regDrugeDrzaveExists) {
      const reviserDataDrDrzave = {
        vrRegistracije: "2",
        nazTijela: nazTijelaDrDrzave,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegDrDrzave,
        datReg: "",
        id: 1,
        type: "",
      };
      reviserData.push(reviserDataDrDrzave);
    }

    if (regTreceZemljeExists) {
      const reviserDataTreceZemlje = {
        vrRegistracije: "2",
        nazTijela: nazTijelaTreceZemlje,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegTreceZemlje,
        datReg: "",
        id: regDrugeDrzaveExists ? 2 : 1,
        type: "",
      };
      reviserData.push(reviserDataTreceZemlje);
    }

    if (!regDrugeDrzaveExists && !regTreceZemljeExists) {
      reviserData.push({
        vrRegistracije: "2",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        id: 1,
        type: "",
      });
    }

    let sifZupanije;
    let nazZupanije;
    let sifGrdOpc;
    let nazGrdOpc;
    let nazNaselja;
    let sifNaselja;
    let cityAndMuncipalityList;
    let districtList;

    if (findCountry[0].value == 191 && findCity[0].value != "") {
      const response = await axiosInstance.get(
        `/sifarnici/grad/${findCity[0].value}`
      );

      sifZupanije = response.data.sifZupanije;
      nazZupanije = response.data.nazZupanije;
      sifGrdOpc = findCity[0].value;
      sifNaselja = findDistrict[0].value;

      const getCityList = await axiosInstance.get(
        `/sifarnici/gradOpcina/${sifZupanije}`
      );
      cityAndMuncipalityList = getCityList.data;

      const getDistrictList = await axiosInstance.get(
        `/sifarnici/naselja/${sifGrdOpc}`
      );
      districtList = getDistrictList.data;

      const findNazivGrada = getCityList.data.filter((element) =>
        element.gradoviOpcine.find((el) => el.sifGrdOpc == sifGrdOpc)
      );

      nazGrdOpc = findNazivGrada[0].gradoviOpcine[0].nazGrdOpc;

      const findNazivNaselja = getDistrictList.data.filter((element) =>
        element.naselja.find((el) => el.sifNaselja == sifNaselja)
      );

      if (findNazivNaselja.length > 0) {
        nazNaselja = findNazivNaselja[0].naselja[0].nazNaselja;
      } else {
        nazNaselja = findDistrict[0].value;
        sifNaselja = "";
      }
    } else {
      nazZupanije = "";
      sifZupanije = "";
      sifNaselja = "";
      nazGrdOpc = findCity[0].value;
      nazNaselja = findDistrict[0].value;
      cityAndMuncipalityList = [];
      districtList = [];
      sifGrdOpc = "";
    }

    const address = {
      ...this.state.newFormData.address,
      sifDrzave: findCountry[0].value,
      sifZupanije: String(sifZupanije),
      nazZupanije,
      sifGrdOpc,
      nazGrdOpc,
      nazNaselja,
      sifNaselja,
      brPoste,
      ulicaKbr,
    };

    this.setState(
      (prevState) => ({
        cityAndMuncipalityList,
        districtList,
        newFormData: {
          ...prevState.newFormData,
          userData: {
            ...prevState.newFormData.userData,
            oibValidated: true,
            oib: data.oib,
            ime: data.ime,
            prezime: data.prezime,
            telefon: findTel[0].value,
            email: findEmail[0].value,
            emailValidated: true,
          },
          address,
          reviserData,
        },
      }),
      () => {
        this.disableLoader();
      }
    );
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );

    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);
    this.setState({ districtList: data }, () => { });
  };

  multiplyComponent = (e, objData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objData.formGroup]];
    const addNewElement =
      (objData.formGroup === "reviserData" && {
        vrRegistracije: "2",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        id: lastElem[lastElem.length - 1].id + 1,
        // requiredFieldsRevData: ["ulicaKbr"],
      }) ||
      (objData.formGroup === "reviserRegistration" && {
        vrVeze: "",
        idDrustva: "",
        oibIdBrojDrustva: "",
        ime: "",
        prezime: "",
        nazDrustva: "",
        dataFetched: false,
        sifDrzave: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        web: "",
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "competentBodyData" && {
        id: lastElem[lastElem.length - 1].id + 1,
        vrRegistracije: "3",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
      });
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  getUserData = async (e) => {
    e.preventDefault();
    e.persist();
    const newState = { ...this.state };
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    const findUserObject = newState.newFormData.reviserRegistration.find(
      (element) => {
        return element.id == id;
      }
    );

    let identifikacija = findUserObject.oibIdBrojDrustva;

    try {
      const res = await axiosInstance.get(
        `/sifarnici/drustva?identifikacija=${identifikacija}`
      );

      const { data } = res;
      if (data.length === 0) {
        return this.props.formSubmitError(true, "Nema dostupnih podataka");
      }

      let userData = {
        funkcija: "",
        vrVeze: data[0].vrDrustva,
        sifDrzave: data[0].sifDrzave.toString(),
        nazNaselja: data[0].nazNaselja || "",
        brPoste: data[0].brPoste || "",
        ulicaKbr: data[0].ulicaKbr || "",
        web: data[0].web || "",
        dataFetched: true,
        id: findUserObject.id,
        idDrustva: data[0].idDrustva.toString(),
        oibIdBrojDrustva: data[0].oib || data[0].idBroj,
        tstampUnosa: data[0].tstampUnosa,
      };

      switch (userData.vrVeze) {
        case 2:
          userData.ime = data[0].ime;
          userData.prezime = data[0].prezime;
          break;
        case 4:
          userData.ime = data[0].ime || "";
          userData.prezime = data[0].prezime || "";
          userData.nazDrustva = data[0].nazDrustva || "";
          break;
        default:
          userData.nazDrustva = data[0].nazDrustva;
          break;
      }
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          reviserRegistration: [
            ...prevState.newFormData.reviserRegistration.map((element) => {
              return element.id == id ? userData : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleMappedUserInput(e, objectData), () => {
      if (
        objectData.group === "reviserRegistration" &&
        e.target.name === "oibIdBrojDrustva"
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.group]: [
              ...prevState.newFormData[objectData.group].map((element) =>
                element.id === objectData.id
                  ? {
                      ...element,
                      sifDrzave: "",
                      nazNaselja: "",
                      brPoste: "",
                      ulicaKbr: "",
                      web: "",
                      dataFetched: false,
                      id: element.id,
                      idDrustva: "",
                      nazDrustva: "",
                    }
                  : element
              ),
            ],
          },
        }));
      }
    });
  };

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };


  validateEmail = (e, objectData) => {
    const value = e.target.value;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(value);

    this.setState((prevState) => ({
      newFormData:{
        ...prevState.newFormData,
        [objectData.group]: {
          ...prevState.newFormData[objectData.group],
          emailValidated,
        }
      }
    }))
    
  };

  userInputHandler = (e, objectData) => {
    e.persist();
    // const name = e.target.id.replace(/[0-9]/g, "");
    const { name } = e.target;
    const isEmail = e.target.id === "email-user-data";

    this.setState(handleUserInput(e, objectData), () => {
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
      isEmail && this.validateEmail(e, objectData);
    });
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);

    //ovo smece treba testirati
    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          ime: data.ime,
          prezime: data.prezime,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  submitHandler = async (e) => {
    e.preventDefault();

    const { zahtjevAtrId } = this.props;
    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );
    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != "191") {
      requiredFieldsAddress = [
        "sifDrzave",
        "nazNaselja",
        "brPoste",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ];
    }

    const isEmailValidated = stateCopy.userData.emailValidated;

    if (!isEmailValidated && stateCopy.userData.email.length > 0) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "E-mail koji ste upisali nije ispravan! (Osnovni podaci)"
        );
      });

      return;
    }
    
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );
    
    const validateReviserRegistartion = stateCopy.reviserRegistration.every((element) => element.dataFetched ? element.funkcija !== '' : true);

    if (!validateUserData || !validateAddress || !validateReviserRegistartion) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (!stateCopy.userData.oibValidated) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    // const checkIfOibIsValid = [...stateCopy.reviserRegistration]
    //   .filter((element) => element.vrVeze != "3" && element.oibDrustva.length > 0)
    //   .every((element) => element.oibValidated);

    // if (!checkIfOibIsValid) {
    //   this.props.formSubmitError(
    //     true,
    //     "Unesite ispravan oib! (Podaci o revizorskom društvu ili samostalnom revizoru)"
    //   );
    //   return;
    // }

    // const checkIfDataIsFetched = [...stateCopy.reviserRegistration].every(
    //   (element) => element.idDrustva
    // );

    // if (!checkIfDataIsFetched) {
    //   this.props.formSubmitError(
    //     true,
    //     "Dohvatite podatke o revizorskom društvu/samostalnom revizoru!"
    //   );
    //   return;
    // }

    let userData = { ...stateCopy.userData };
    delete userData.requiredFieldsUserData;
    delete userData.oibValidated;
    delete userData.oznAkt;
    delete userData.emailValidated;

    let address = { ...stateCopy.address };

    const addressReg = {
      vrRegistracije: "1",
      sifDrzave: address.sifDrzave,
      brReg: address.permitNumber,
      datReg: address.permitDate,
    };

    const registrationArray = [];

    const reviserData = [...this.state.newFormData.reviserData].map(
      (element) => {
        return {
          vrRegistracije: element.vrRegistracije,
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          brReg: element.brReg,
          datReg: element.datReg,
        };
      }
    );
    delete address.requiredFieldsAddress;
    delete address.permitDate;
    delete address.permitNumber;
    
    let reviserSustainabilityApproval = { ...stateCopy.reviserSustainabilityApproval };

    const clanstva = [
      ...this.state.newFormData.reviserRegistration,
    ].filter((element)=> element.funkcija !==1 && element.funkcija);

    const revizorstva = [
      ...this.state.newFormData.reviserRegistration,
    ].filter((element) => element.funkcija === 1 && element.funkcija);

    const reviserRegistration = revizorstva.map((element) => {
      if (element.idDrustva) {
        return {
          idDrustva: element.idDrustva,
          vrVeze: "1",
        };
      }
      return {
        idDrustva: "",
        vrVeze: "",
      };
    });

    const reviserMembership = clanstva.map((element)=>{
        if(element.idDrustva){
        let _clanDrustvo = {
          idDrustva: element.idDrustva,
          ime: userData.ime,
          prezime: userData.prezime,
          oib: userData.oib,
          //dodati sta jos treba
            nazNaselja:element.nazNaselja,
          brPoste: element.brPoste,
            ulicaKbr:element.ulicaKbr,
            sifDrzave:element.sifDrzave,
          }
        switch (element.funkcija) {
          case 2:
            return {
              ..._clanDrustvo,
                vrClana:1,
                funkcija:"Dioničar/član društva",
              }
          case 3:
            return {
              ..._clanDrustvo,
                vrClana:2,
                funkcija:"Direktor",
              }
          case 4:
            return {
              ..._clanDrustvo,
                vrClana:2,
                funkcija:"Predsjednik uprave" ,
              }
          case 5:
            return {
              ..._clanDrustvo,
                vrClana:2,
                funkcija:"Član uprave" ,
              }
          case 6:
            return {
              ..._clanDrustvo,
                vrClana:2,
                funkcija:"Prokurist",
              }
          case 7:
            return {
              ..._clanDrustvo,
                vrClana:2,
                funkcija:"Član upravnog odbora",
              }
          default:
            return {
                idDrustva:"",
                vrClana:"",
              }
        }
      }
    });

    let competentBodyData = [...this.state.newFormData.competentBodyData].map(
      (element) => {
        return {
          vrRegistracije: "3",
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );

    registrationArray.push(addressReg, ...reviserData, ...competentBodyData);
    const { oznDokumenta } = this.state.newFormData;
    const submitData = [
      1,
      userData,
      address,
      registrationArray,
      reviserRegistration,
      oznDokumenta,
      reviserMembership,
      [{}],
    ];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        submitData.push([]);
        submitData.push(reviserSustainabilityApproval);
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      submitData.push(stateCopy.mjere);
      submitData.push(reviserSustainabilityApproval);
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
          "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();

    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");
    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  dropdownHandler = (e) => {
    //TODO: testirati
    //replace
    e.persist();
    const id = e.target.id.replace(/[^0-9]/g, "");
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        reviserRegistration: [
          ...prevState.newFormData.reviserRegistration.map((element) => {
            return element.id == id
              ? {
                  ...element,
                  funkcija: Number(e.target.value),
                }
              : element;
          }),
        ],
      },
    }));
  };

  render() {
    const otherProps = {
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      dropdownHandler: this.dropdownHandler,
      getUserData: this.getUserData,
      handleDayClick: this.handleDayClick,
      removeComponentHandler: this.removeComponentHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm3
            {...otherProps}
            submitHandler={this.submitHandler}
            autocompleteHandler={this.autocompleteHandler}
            multiplyComponent={this.multiplyComponent}
            mappedUserInputHandler={this.mappedUserInputHandler}
            userInputHandler={this.userInputHandler}
            parentState={this.state}
          />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idOsobe: state.update.idOsobe,
    vrOsobe: state.update.vrOsobe,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarOvlastenihRevizora);
